
const routers = [
  {
    path: "/",
    redirect: "/auth",
    auth: false,
  },
  // About for mobile
  {
    component: "AboutMobile",
    path: "/aboutPage",
    componentPath: "pages/About",
    name: "AboutMobile",
    auth: false,
    exact: true,
  },
  // Policies for mobile

  {
    component: "Policies",
    path: "/policies",
    componentPath: "pages/Policy",
    name: "Policies",
    auth: false,
    exact: true,
  },
  // Terms for mobile

  {
    component: "Terms",
    path: "/terms",
    componentPath: "pages/Terms",
    name: "Terms",
    auth: false,
    exact: true,
  },
  {
    component: "AuthLayout",
    path: "/auth",
    auth: false,
    name: "Auth",
    exact: false,
    redirect: "/auth/login",
    childrens: [
      {
        component: "Login",
        path: "/login",
        componentPath: "pages/Auth/Login",
        name: "Login",
        auth: false,
        exact: true,
      },
      {
        component: "Reset",
        path: "/reset",
        componentPath: "pages/Auth/Reset",
        name: "Reset",
        auth: false,
        exact: true,
      },
      {
        component: "MailResetComp",
        path: "/MailReset",
        componentPath: "pages/Auth/MailReset",
        name: "MailResetComp",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/dashboard",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Dashboard",
        path: "/",
        componentPath: "pages/Dashboard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "ProductiveWorks",
        path: "/productiveWorks",
        componentPath: "pages/ProductiveWorks",
        name: "ProductiveWorks",
        auth: false,
        exact: true,
      },
      {
        component: "NonProductive",
        path: "/nonProductive",
        componentPath: "pages/NonProductive",
        name: "NonProductive",
        auth: false,
        exact: true,
      },
    ],
  },
  //Project
  {
    component: "MainLayout",
    path: "/projects",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Projects",
        path: "/",
        componentPath: "pages/Project",
        name: "Projects",
        auth: false,
        exact: true,
      },
      {
        component: "ProjectDetail",
        path: "/view/:project_id",
        componentPath: "pages/ProjectDetails",
        name: "ProjectDetail",
        auth: false,
        exact: true,
      },
      {
        component: "AddProjects",
        path: "/add",
        componentPath: "pages/AddProject",
        name: "AddProjects",
        auth: false,
        exact: true,
      },
      {
        component: "AddProjects",
        path: "/edit/:project_id",
        componentPath: "pages/AddProjects",
        name: "AddProjects",
        auth: false,
        exact: true,
      },
      {
        component: "EditProjects",
        path: "/edit",
        componentPath: "pages/EditProjects",
        name: "EditProjects",
        auth: false,
        exact: true,
      },
      {
        component: "UploadProject",
        path: "/upload",
        componentPath: "pages/UploadProject",
        name: "UploadProject",
        auth: false,
        exact: true,
      },
    ],
  },
  //User Management
  {
    component: "MainLayout",
    path: "/users",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Users",
        path: "/",
        componentPath: "pages/User-management",
        name: "User",
        auth: false,
        exact: true,
      },
      {
        component: "AddUsers",
        path: "/add",
        componentPath: "pages/AddUserManagement",
        name: "AddUsers",
        auth: false,
        exact: true,
      },
      {
        component: "EditUsers",
        path: "/edit",
        componentPath: "pages/EditUserManagement",
        name: "EditUsers",
        auth: false,
        exact: true,
      },
      {
        component: "UserDetail",
        path: "/view",
        componentPath: "pages/UserDetails",
        name: "UserDetail",
        auth: false,
        exact: true,
      },
      {
        component: "UploadUsers",
        path: "/upload",
        componentPath: "pages/UploadUser",
        name: "UploadUsers",
        auth: false,
        exact: true,
      },
    ],
  },
  //Activities
  {
    component: "MainLayout",
    path: "/activities",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Activities",
        path: "/",
        componentPath: "pages/Activities",
        name: "Activities",
        auth: false,
        exact: true,
      },
      {
        component: "ActivityDetails",
        path: "/view/:activity_master_id/:active_status",
        componentPath: "pages/ActivityDetail",
        name: "ActivityDetails",
        auth: false,
        exact: true,
      },
      {
        component: "UploadActivities",
        path: "/upload",
        componentPath: "pages/UploadActivities",
        name: "UploadActivities",
        auth: false,
        exact: true,
      },
      {
        component: "AddActivities",
        path: "/add",
        componentPath: "pages/AddActivity",
        name: "AddActivities",
        auth: false,
        exact: true,
      },
      {
        component: "EditActivities",
        path: "/edit/:activity_master_id/:active_status",
        componentPath: "pages/EditActivity",
        name: "EditActivities",
        auth: false,
        exact: true,
      },
    ],
  },
  //Reports
  {
    component: "MainLayout",
    path: "/reports",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Reports",
        path: "/",
        componentPath: "pages/Reports",
        name: "Reports",
        auth: false,
        exact: true,
      },
      {
        component: "ReportDetails",
        path: "/view",
        componentPath: "pages/ReportDetail",
        name: "ReportDetails",
        auth: false,
        exact: true,
      },
      {
        component: "EditReports",
        path: "/edit",
        componentPath: "pages/EditReport",
        name: "EditReports",
        auth: false,
        exact: true,
      },
    ],
  },
  //Attendance Report
  {
    component: "MainLayout",
    path: "/attendanceReports",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Attendance",
        path: "/",
        componentPath: "pages/AttendanceReport",
        name: "Attendance",
        auth: false,
        exact: true,
      },
      {
        component: "AddAttendance",
        path: "/add",
        componentPath: "pages/AddAttendances",
        name: "AddAttendance",
        auth: false,
        exact: true,
      },
      {
        component: "UploadAttendance",
        path: "/upload",
        componentPath: "pages/UploadAttendances",
        name: "UploadAttendance",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "MainLayout",
    path: "/manualCron",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "ManualCron",
        path: "/",
        componentPath: "pages/ManualCron",
        name: "ManualCron",
        auth: false,
        exact: true,
      },
    ],
  },
  //Productivity
  {
    component: "MainLayout",
    path: "/productivity",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Productivity",
        path: "/",
        componentPath: "pages/Productivity",
        name: "Productivity",
        auth: false,
        exact: true,
      },
    ],
  },
  //About
  {
    component: "MainLayout",
    path: "/about",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "About",
        path: "/",
        componentPath: "pages/Aboutus",
        name: "About",
        auth: false,
        exact: true,
      },
    ],
  },
  //Terms and Policies
  {
    component: "MainLayout",
    path: "/termsPolicies",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "TermsPolicies",
        path: "/",
        componentPath: "pages/TermsPolicies",
        name: "TermsPolicies",
        auth: false,
        exact: true,
      },
    ],
  },
  //Settings
  {
    component: "MainLayout",
    path: "/settings",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "Settings",
        path: "/",
        componentPath: "pages/Settings",
        name: "Settings",
        auth: false,
        exact: true,
      },
    ],
  },
  //Master
  {
    component: "MainLayout",
    path: "/master/:mode",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "MasterPage",
        path: "/",
        componentPath: "pages/Master",
        name: "master",
        auth: false,
        exact: true,
      },
      {
        component: "AddRegion",
        path: "/region/add",
        componentPath: "pages/Master/region/regionadd",
        name: "Region",
        auth: false,
        exact: true,
      },
      {
        component: "EditRegion",
        path: "/region/edit/:id",
        componentPath: "pages/Master/region/regionedit",
        name: "Edit Region",
        auth: false,
        exact: true,
      },
      {
        component: "AddWings",
        path: "/wings/add",
        componentPath: "pages/Master/wings/wingsAdd.jsx",
        name: "Add Wings",
        auth: false,
        exact: true,
      },
      {
        component: "EditWings",
        path: "/wings/edit/:id",
        componentPath: "pages/Master/wings/wingsEdit.jsx",
        name: "Edit Wings",
        auth: false,
        exact: true,
      },
      {
        component: "AddFloor",
        path: "/floor/add",
        componentPath: "pages/Master/floors/floorsAdd.jsx",
        name: "Add Floor",
        auth: false,
        exact: true,
      },
      {
        component: "EditFloor",
        path: "/floor/edit/:id",
        componentPath: "pages/Master/floors/floorsEdit.jsx",
        name: "Edit Floor",
        auth: false,
        exact: true,
      },
      {
        component: "AddUnit",
        path: "/units/add",
        componentPath: "pages/Master/units/unitAdd.jsx",
        name: "Add Unit",
        auth: false,
        exact: true,
      },
      {
        component: "EditUnit",
        path: "/units/edit/:id",
        componentPath: "pages/Master/units/unitEdit.jsx",
        name: "Edit Unit",
        auth: false,
      },
      {
        component: "AddWorkArea",
        path: "/work-area/add",
        componentPath: "pages/Master/workarea/workareaAdd.jsx",
        name: "Add Work Area",
        auth: false,
        exact: true,
      },
      {
        component: "EditWorkArea",
        path: "/work-area/edit/:id",
        componentPath: "pages/Master/workarea/workAreaEdit.jsx",
        name: "Edit Work Area",
        auth: false,
        exact: true,
      },
      {
        component: "MasterViewPage",
        path: "/:entity/view/:id",
        componentPath: "pages/Master/MasterViewPage.jsx",
        name: "View Master Details",
        auth: false,
        exact: true,
      },
    ],
  },
  //Master Quantity
  {
    component: "MainLayout",
    path: "/MasterQuantity",
    auth: false,
    name: "MainLayout",
    exact: false,
    childrens: [
      {
        component: "MasterQuantity",
        path: "/",
        componentPath: "pages/MasterQuantity",
        name: "MasterQuantity",
        auth: false,
        exact: true,
      },
      {
        component: "ViewMasterQuanity",
        path: "/view/:id",
        componentPath: "pages/MasterQuantity/ViewMasterQuanity",
        name: "ViewMasterQuanity",
        auth: false,
        exact: true,
      },
      {
        component: "MasterQuantityAddComponent",
        path: "/add/:id",
        componentPath: "pages/MasterQuantity/MasterQuantityAdd",
        name: "MasterQuantityAdd",
        auth: false,
        exact: true,
      },
    ],
  },
];

export default routers;
